// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bcms-select-container {
  display:inline-block;
}

.bcms-select-selected {
  border:1px solid #000;
  background :#FFF;
  color: #000;
  padding:5px;
  cursor:pointer;
}

.bcms-select-dropdown {
  background:#fff;
  border:1px solid #000;
  border-top:0px;
  border-bottom:0px;
  position: absolute;
  box-sizing: border-box;
  display:none;
}

.bcms-select-dropdown.open {
  display:block;
}

.bcms-select-item {
  border-bottom:1px solid #000;
  padding:5px;
  cursor:pointer;
}

.bcms-select-item:hover {
  background:blue;
  color:#fff;
}

.bcms-select-item.selected {
  color:#ccc;
  background:blue;
  opacity:.5;
  cursor:default;
}
`, "",{"version":3,"sources":["webpack://./src/components/BCMSSelect/styles.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,UAAU;EACV,cAAc;AAChB","sourcesContent":[".bcms-select-container {\n  display:inline-block;\n}\n\n.bcms-select-selected {\n  border:1px solid #000;\n  background :#FFF;\n  color: #000;\n  padding:5px;\n  cursor:pointer;\n}\n\n.bcms-select-dropdown {\n  background:#fff;\n  border:1px solid #000;\n  border-top:0px;\n  border-bottom:0px;\n  position: absolute;\n  box-sizing: border-box;\n  display:none;\n}\n\n.bcms-select-dropdown.open {\n  display:block;\n}\n\n.bcms-select-item {\n  border-bottom:1px solid #000;\n  padding:5px;\n  cursor:pointer;\n}\n\n.bcms-select-item:hover {\n  background:blue;\n  color:#fff;\n}\n\n.bcms-select-item.selected {\n  color:#ccc;\n  background:blue;\n  opacity:.5;\n  cursor:default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
